import { Badge } from "../components/ui/badge.js";
import type { SubscriptionStatus } from "../lib/admin.js";

const TONE: Readonly<Record<SubscriptionStatus, string>> = {
  active: "border-transparent bg-emerald-500/15 text-emerald-700 dark:text-emerald-400",
  trialing: "border-transparent bg-blue-500/15 text-blue-700 dark:text-blue-400",
  past_due: "border-transparent bg-amber-500/15 text-amber-700 dark:text-amber-400",
  paused: "border-transparent bg-slate-500/15 text-slate-600 dark:text-slate-300",
  canceled: "border-transparent bg-red-500/15 text-red-700 dark:text-red-400",
};

const LABEL: Readonly<Record<SubscriptionStatus, string>> = {
  active: "Active",
  trialing: "Trialing",
  past_due: "Past due",
  paused: "Paused",
  canceled: "Canceled",
};

export function StatusBadge({ status }: { readonly status: SubscriptionStatus }): React.JSX.Element {
  return <Badge className={TONE[status]}>{LABEL[status]}</Badge>;
}
